module.exports = __webpack_public_path__ + "static/media/scroll-old.cc0091c0.svg";